// /Users/giz/code/nir/ai/arnold/frontend/src/Components/SmartTextArea/TextWithCursor.js

import { useRef, useState, useLayoutEffect } from "react";
import GraphemeSplitter from "grapheme-splitter";
import Floater from './Floater'
import TopNPanel from './TopNPanel';
import styles from "./SmartTextArea.module.scss";

const splitter = new GraphemeSplitter();

export default function TextWithCursor({
                                         text,
                                         isWithCursorAndTopN = true,
                                         topN,
                                         selectedTopNIndex,
                                         isTopNPanelOpen,
                                         highlightRange = null,
                                       }) {
  const containerRef = useRef(null);
  const cursorRef = useRef(null);
  const [lines, setLines] = useState([]);
  const [containerWidth, setContainerWidth] = useState(0);

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    if (!containerRef.current || containerWidth === 0) return;

    const computedStyle = getComputedStyle(containerRef.current);
    const fontSizePx = parseFloat(computedStyle.fontSize);

    const ctx = document.createElement("canvas").getContext("2d");
    ctx.font = `${fontSizePx}px monospace`;

    const srcText = text ?? '';

    const chars = splitter.splitGraphemes(srcText)
    const computedLines = [];
    let currentLine = [];
    let currentWidth = 0;
    let y = 0;
    let pos = 0;

    chars.forEach((char) => {
      const width = ctx.measureText(char).width;

      const isHighlight =
        !!highlightRange && pos >= highlightRange.start && pos < highlightRange.end;

      if (currentWidth + width > containerWidth && currentLine.length > 0) {
        computedLines.push(currentLine);
        currentLine = [];
        currentWidth = 0;
        y += 1;
      }

      currentLine.push({ char, isHighlight, y })
      currentWidth += width;
      pos += char.length
    });

    if (currentLine.length > 0) {
      computedLines.push(currentLine)
    }

    setLines(computedLines)
  }, [text, containerWidth, highlightRange]);

  return (
    <div className={styles.textWithCursor} ref={containerRef}>
      {lines.map((line, rowIndex) => (
        <div className={styles.lines} key={rowIndex}>
          {line.map(({ char, isHighlight }, i) => (
            <span
              key={i}
              className={isHighlight
                ? `${styles.line} ${styles.ttsWordHighlight}`
                : styles.line}
            >
              {char}
            </span>
          ))}
          {isWithCursorAndTopN && rowIndex === lines.length - 1 && (
            <div className={styles.cursorAndTopNPanel}>
              <span className={styles.cursor} ref={cursorRef} />
              <Floater anchorRef={cursorRef} offsetY={10}>
                <TopNPanel
                  topN={topN}
                  selectedTopNIndex={selectedTopNIndex}
                  isTopNPanelOpen={isTopNPanelOpen}
                />
              </Floater>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
